import React, { useState } from "react";
import "./Sidebar.css";
import {
  FiHome,
  FiUsers,
  FiBook,
  FiHelpCircle,
  FiCast,
  FiMenu,
  FiX,
} from "react-icons/fi";
import { useTranslation } from "react-i18next";

import logoImg from "../../assets/logo.png";
import awardsImg from "../../assets/WIN_AF.png";
import beeyouIcon from "../../assets/beeyou.jpg";
import CTASection from "./CTABouton";

function Sidebar({ isScrolled, activeTab, setActiveTab, showMobileNav }) {
  const { t, i18n } = useTranslation();

  const [isMobileLangOpen, setIsMobileLangOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { id: "home", label: t("nav.home"), icon: <FiHome /> },
    { id: "team", label: t("nav.team"), icon: <FiUsers /> },
    { id: "chapter", label: t("nav.chapter"), icon: <FiBook /> },
    {
      id: "news",
      label: t("nav.news", "Actualité"),
      icon: <FiCast />,
      isMobileOnly: true,
    },
    {
      id: "acefundtv",
      label: t("nav.tv", "Acefund TV"),
      icon: <img src={beeyouIcon} alt="TV" className="custom-nav-icon" />,
      externalLink: "https://www.beeyou.tv/acefund",
    },
    { id: "faq", label: t("nav.faq"), icon: <FiHelpCircle /> },
  ];

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    setIsMobileLangOpen(false);
  };

  const handleNavigation = (item) => {
    setIsMobileMenuOpen(false);
    if (item.externalLink) {
      window.open(item.externalLink, "_blank", "noopener,noreferrer");
    } else {
      setActiveTab(item.id);
    }
  };

  return (
    <div
      className={`sidebar-wrapper ${isScrolled ? "collapsed" : ""} ${
        !showMobileNav ? "mobile-hidden" : ""
      }`}
    >
      <div className="logo-container">
        <img src={logoImg} alt="AceFund Logo" className="sidebar-logo" />
      </div>

      <button
        className="mobile-burger-btn"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        {isMobileMenuOpen ? <FiX /> : <FiMenu />}
      </button>

      <nav
        className={`sidebar-nav glass-panel ${isMobileMenuOpen ? "mobile-open" : ""}`}
      >
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`nav-btn ${activeTab === item.id ? "active" : ""} ${
              item.isMobileOnly ? "mobile-only-btn" : ""
            }`}
            onClick={() => handleNavigation(item)}
            type="button"
          >
            {item.icon}
            <span>{item.label}</span>
          </button>
        ))}

        <div className="nav-cta-container">
          <CTASection
            onNavigate={() => {
              setActiveTab("join-club");
              setIsMobileMenuOpen(false);
            }}
          />
        </div>

        <div className="language-switcher-desktop">
          <button
            onClick={() => changeLang("fr")}
            className={`lang-btn ${i18n.language.startsWith("fr") ? "active" : ""}`}
          >
            FR
          </button>
          <span className="lang-separator">|</span>
          <button
            onClick={() => changeLang("en")}
            className={`lang-btn ${i18n.language.startsWith("en") ? "active" : ""}`}
          >
            EN
          </button>
        </div>

        <div className="language-switcher-mobile">
          <div
            className={`mobile-lang-popup ${isMobileLangOpen ? "open" : ""}`}
          >
            <button
              onClick={() => changeLang("fr")}
              className={i18n.language.startsWith("fr") ? "active" : ""}
            >
              🇫🇷 Français
            </button>
            <button
              onClick={() => changeLang("en")}
              className={i18n.language.startsWith("en") ? "active" : ""}
            >
              🇬🇧 English
            </button>
          </div>
          <button
            className="mobile-lang-trigger"
            onClick={() => setIsMobileLangOpen(!isMobileLangOpen)}
          >
            {i18n.language.startsWith("fr") ? "FR" : "EN"}
          </button>
        </div>
      </nav>

      <div className="awards-container">
        <img src={awardsImg} alt="Awards CES 2024" className="awards-img" />
      </div>
    </div>
  );
}

export default Sidebar;
